import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/services/authentication.service';
import { Baseservice } from 'app/services/baseservice';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarrierDriverService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("driver", http, authentication);
  }

  getDriverList() {
    return this.getRequest(`${this.url}`);
  }

  addDriver(obj) {
    return this.http.post(`${this.url}`, obj);
  }

  updateDriver(obj) {
    return this.http.put(`${this.url}`,obj);
  }

  getDriverDetails(depotId) {
    return this.getRequest(`${this.url}/${depotId}`);
  }
  getDriversByCarrierId(id){
    return this.http.get(environment.iCBMSWebApi.url + 'depot/by-carrier-id/'+id);
  }
  getCarrierDrivers(id){
    return this.http.get(this.url + '/bycarrier/'+id);
  }
}
